var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'chart-container',
        (_vm.size=='sm')?'chart-container--small':''
    ]},[_c('canvas',{staticClass:"chart-gauge gauge-small",attrs:{"id":"chart-gauge"}})])}
var staticRenderFns = []

export { render, staticRenderFns }